import { SubscriptionStoreState, useSubscriptionStore } from '../subscriptionStore';

export const getIsOnTrial = (state?: SubscriptionStoreState) => {
  return Boolean((state ?? useSubscriptionStore.getState()).isOnTrial);
};
